if($('footer#footer').length){
    $('#signature').append('<span class="sigantureFirm"> | <a href="https://www.shopcode.cz/" target="_blank">ShopCode</a></span>')
    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    })
}